var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Represents the top bar component of the application.
 *
 * @param {number} drawerWidth - The width of the drawer.
 * @param {() => void} handleDrawerToggle - The function to handle the drawer toggle.
 * @returns {JSX.Element} The rendered top bar component.
 */
import { AppBar, IconButton, Toolbar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import beerWikiLogo from "../../images/beerWikiLogo.png";
import OptimizedImage from "../OptimizedImage";
import styles from "./TopBar.module.css";
var TopBar = function (props) {
    return (_jsx(AppBar, __assign({ position: "fixed", sx: {
            width: { sm: "calc(100% - ".concat(props.drawerWidth, "px)") },
            ml: { sm: "".concat(props.drawerWidth, "px") },
        }, component: "header", role: "banner" }, { children: _jsxs(Toolbar, { children: [_jsx(IconButton, __assign({ color: "inherit", "aria-label": "Toggle navigation menu", "aria-expanded": "false", edge: "start", onClick: props.handleDrawerToggle, sx: { mr: 2, display: { sm: "none" } } }, { children: _jsx(MenuIcon, {}) })), _jsx(OptimizedImage, { src: beerWikiLogo, alt: "Beer Wiki - Navigate to homepage", className: styles.topBarLogo, width: 200, height: 40 })] }) })));
};
export default TopBar;
